<div class="general-container">
    <div class="item-is-here" *ngIf="!(jobcard.collectionsDeliveries?.allowCollection)">
        <hub-checkbox [(ngModel)]="jobcard.itemIsHere"
            [label]="'bikeshop.workshop.jobcard.items.the_item_is_at_the_shop' | translate"></hub-checkbox>
    </div>

    <div class="item-bay-number" *ngIf="jobcard.itemIsHere">
      <div>
        <!--<hub-input [label]="'bikeshop.workshop.jobcard.items.bay_tag_no' | translate"
             [(ngModel)]="jobcard.bayNo"></hub-input>-->
        <hub-input *ngIf="bays.length == 0" #bayTagNoInput [label]="'bikeshop.workshop.jobcard.items.bay_tag_no' | translate"
                   [(ngModel)]="jobcard.bayNo"></hub-input>

        <hub-dropdown #bayDropdown *ngIf="bays.length > 0" [formatList]="bays" [label]="'bikeshop.workshop.jobcard.items.bay_tag_no' | translate" (ngModelChange)="onBayTagNoChanged($event)"
                      [(ngModel)]="bay" [options]="bays" [optionLabel]="'label'" [optionValue]="'value'"></hub-dropdown>



      </div>
        <div>
            <hub-button [icon]="'trash'" [iconColor]="'var(--iso-radish-500)'" [style]="'outline'" [size]="'xl'" [disabled]="!jobcard.bayNo"
             (buttonClick)="jobcard.bayNo = ''"></hub-button>
        </div>
    </div>
</div>

<div class="margin-top-8">
    <div *ngIf="!jobcard.clientNotes">
        <hub-button [icon]="'plus'" [style]="'borderless-secondary'" [size]="'sm'"
            text="{{'bikeshop.workshop.jobcard.customer.add_booking_notes' | translate }}"
            (buttonClick)="addBookingNotes()"></hub-button>
    </div>
    <div *ngIf="jobcard.clientNotes">
        <div class="booking-notes-header">{{ 'bikeshop.workshop.jobcard.customer.booking_notes' | translate }}</div>
        <div class="booking-notes-container">
            <div>{{jobcard.clientNotes}}</div>
            <div class="actions">
                <hub-button [icon]="'pencil'" [style]="'borderless-secondary'" [size]="'lg'"
                    (buttonClick)="addBookingNotes()"></hub-button>
                <hub-button [icon]="'cross'" [style]="'borderless-secondary'" [size]="'lg'"
                    (buttonClick)="clearBookingNotes()"></hub-button>
            </div>
        </div>
    </div>
</div>
